<div class="-footer-left-nav"></div>
<div class="-footer-body">
  <app-footer mode="secondary"></app-footer>   
</div>